import { useState, useEffect, useCallback } from "react";

import { api_without_cancellation } from "../../../api/api";
import { getCaseId, getClientId } from "../../../Utils/helper";

const usePropertyDamage = () => {
  const [propertyDamage, setPropertyDamage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [error, setError] = useState(null);
  const clientId = getClientId();
  const caseId = getCaseId();
  const fetchPropertyDamage = useCallback(async () => {
    if (!clientId || !caseId) return;

    setIsLoading(true);
    setIsError(false);
    setError(null);

    try {
      const { data } = await api_without_cancellation.get(
        `/api/property-damage/${clientId}/${caseId}/`
      );
      setPropertyDamage(data);
    } catch (err) {
      setIsError(true);
      setError(err);
    } finally {
      setIsLoading(false);
    }
  }, [clientId, caseId]);

  useEffect(() => {
    fetchPropertyDamage();
  }, [fetchPropertyDamage]);

  return {
    propertyDamage,
    isLoading,
    isError,
    error,
    refetch: fetchPropertyDamage,
  };
};

export default usePropertyDamage;
